import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const GET_PAYMENT_ACCOUNT = gql(`
  query getPaymentAccount($organizationSlug: String!) {
    organization (organizationSlug: $organizationSlug) {
      ... on Organization {
        id
        paymentAccount {
          status
          id
        }
        hasCustomerAccount
      }
    }
  }
`);

type Props = {
  organizationSlug: string;
  skip?: boolean;
};

export function usePaymentAccount({ organizationSlug, skip }: Props) {
  return useQuery(GET_PAYMENT_ACCOUNT, {
    variables: { organizationSlug },
    skip: !organizationSlug || skip
  });
}
